import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ConnectionTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('ConnectionTypeReference');
  }
}
